let apiBase = {
  queryList:'/api/active/list',
  add:'/api/active/add',
  update:'/api/active/update',
  queryDetail:'/api/active/detail',
  delete:'/api/active/delete',
  open:'/api/active/open',
  close:'/api/active/close',
  
}
let ActivityServerObject = null
class ActivityServer{
  constructor(){}

  // 查询活动列表
  queryList(data={}){
    return $http({
      url: apiBase.queryList,
      method: 'post',
      data: data,
    })
  }
  add(data={}){
    return $http({
      url: apiBase.add,
      method: 'post',
      data: data,
    })
  }
  update(data={}){
    return $http({
      url: apiBase.update,
      method: 'post',
      data: data,
    })
  }
  queryDetail(data={}){
    return $http({
      url: apiBase.queryDetail,
      method: 'post',
      data: data,
    })
  }
  delete(data={}){
    return $http({
      url: apiBase.delete,
      method: 'post',
      data: data,
    })
  }
  open(data={}){
    return $http({
      url: apiBase.open,
      method: 'post',
      data: data,
    })
  }
  close(data={}){
    return $http({
      url: apiBase.close,
      method: 'post',
      data: data,
    })
  }
  
}
function singleActivityServer(){
  if(ActivityServerObject === null){
    ActivityServerObject = new ActivityServer()
  }
  return ActivityServerObject
}
export default singleActivityServer()